"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createClient = createClient;
var _routing = require("../../routing.cjs");
function createClient(api) {
  async function list(newsroomId) {
    const url = generateUrl(newsroomId);
    const {
      members
    } = await api.get(url);
    return members;
  }
  async function member(newsroomId, memberId) {
    const url = generateUrl(newsroomId, memberId);
    const {
      member
    } = await api.get(url);
    return member;
  }
  async function link(newsroomId, memberId, options = {}) {
    const {
      is_displaying_stories_in_hub
    } = options;
    const url = generateUrl(newsroomId, memberId);
    const {
      member
    } = await api.post(url, {
      payload: {
        is_displaying_stories_in_hub
      }
    });
    return member;
  }
  async function linkMany(newsroomId, payload) {
    const url = generateUrl(newsroomId);
    const {
      members
    } = await api.post(url, {
      payload
    });
    return members;
  }
  async function unlink(newsroomId, memberId) {
    await api.delete(generateUrl(newsroomId, memberId));
  }
  return {
    list,
    member,
    link,
    linkMany,
    unlink
  };
}
function generateUrl(newsroomId, memberId) {
  const url = _routing.routing.newsroomHubUrl.replace(':newsroom_id', String(newsroomId));
  if (typeof memberId === 'undefined') {
    return url;
  }
  return `${url}/${String(memberId)}`;
}